import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * Password Requirement
 * 
 * @returns {ValidatorFn}
 */
export function nonZeroValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        return control.value != 0 ? null : { isZero: true };
    };
}

/**
 * Action allow
 * 
 * @returns {ValidatorFn}
 */
export function availableValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const availableCountControl = control.parent?.get('availableCount') ? control.parent?.get('availableCount') : { value: 0 };
        return control.value + availableCountControl.value >= 0 ? null : { actionNotAllowed: true };
    };
}